// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__qe2Uz","inputWrap":"CustomTip_inputWrap__2knZt"};